import { ANNUAL_DEACTIVATION,SESSION_DEACTIVATION,PERMANENT_DEACTIVATION,OTHER } from "./enums/memberCoverageInactivityReasons";

import { MAX_DECIMAL } from "../../../../../../common/Configurations/DecimalConfiguration";
import { WAIVED } from "../../../../client/members/member/coverage/enums/memberCoverageGuaranteeTypes";

export const MEMBER_COVERAGE_VALIDATION_RULES = {
  startDate: {
    isRequiredTrim: {
      value: true,
    },
    higherThan: {
      value: {
        field: "furthestDate",
        customMessageKey: "validation.customMessages.coverageStartDate",
      },
    },
  },
  endDate: {
    higherThan: {
      value: {
        field: "startDate",
        customMessageKey: "validation.customMessages.endDate",
      },
    },
  },
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  isInactive: {
    isRequiredBoolean: {
      value: true,
    },
  },
  isInactiveReasonType: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactive",
        expectedValues: [true],
      },
    },
  },
  isInactiveOtherReason: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactiveReasonType",
        expectedValues: [OTHER.value],
      },
    },
  },
  isInactiveWithdrawalDate: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactiveReasonType",
        expectedValues: [PERMANENT_DEACTIVATION.value, ANNUAL_DEACTIVATION.value,SESSION_DEACTIVATION.value],
      },
    },
  },
  classId: {
    isRequiredTrim: {
      value: true,
    },
  },
  divisionId: {
    isRequiredTrim: {
      value: true,
    },
  },
  salary: {
    isRequiredTrim: {
      value: true,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  memberCoverageGuarantees: {
    array: {
      coverageType: {
        isRequiredTrimIfFieldsValueDoesNotEqual: {
          value: {
            expectedValues: [WAIVED.value]
          },
        }
      },
      invoicedClientRate: {
        isRequiredTrim: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      allowance: {
        isRequiredTrim: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      volume: {
        isRequiredTrim: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      formulaMspa: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
    },
    atLeastOne: {
      value: {
        field: "checked",
        expectedValue: true,
        customMessageKey: "memberCoverages.validation.guaranteeSelection",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/memberCoverageValidationRules.js